import Vue from 'vue'
import { Component, Watch } from 'vue-property-decorator'
import * as types from '@board/store/types'
import { loadScript } from '@appbase/util/script-loader'
import { mapActions, mapGetters, mapMutations } from 'vuex'

import { LoadingBar } from '@appbase/components/loading'
import SearchBox from '@board/components/common/SearchBox.vue'
import Paginate from '@board/components/common/Paginate.vue'
import TotalBoardList from '@board/components/board/TotalBoardList.vue'
import menuHelper from '@/modules/@appbase/util/menu-helper'



@Component({
    components: {
        LoadingBar,
        SearchBox,
        TotalBoardList,
        Paginate                
    },

    computed: mapGetters({
        pageSet: types.FETCH_TOTALPAGESET
    }),

    methods: {
        ...mapMutations({
            fetchPageset: types.FETCH_TOTALPAGESET
        })
    }
})
export default class TotalBoardMain  extends Vue {
    fetchPageset!: (payload: boardModule.state.TotalPageSet) => void;

    pageSet!: boardModule.state.TotalPageSet;

    boardGroup: number | null = 1;

    searchBoxCriterias: common.SearchBoxCriteria[] = [
        { displayName: this.$t('제목').toString(), value: '1' },
        { displayName: this.$t('본문').toString(), value: '2' },
        { displayName: this.$t('제목___본문').toString(), value: '30' },
        { displayName: this.$t('작성자').toString(), value: '4' },
        { displayName: this.$t('첨부파일').toString(), value: '3' }
    ];

    ofString: string = ''
    totalCount: number = 0;
    totalPage: number = 0;

    created() {
        var _this = this;
        this.boardGroup = Number(this.$route.query.MENUID)
        this.onChangedMENUID(this.$route.query.MENUID as string)
        if((window as any).eumBoardIds) {
            this.mountAction();
        } else {
            loadScript('/cm/gres/js/boardFieldSetting.js', 'eum-board-setting', function () {
                _this.mountAction();
            })
        }
    }

    mountAction() {
        // this.setPage({ title: '새소식' });
        this.fetchPageset({
            currentPage: 1,
            groupId: this.boardGroup,
            searchField: 0,
            searchText: null
        })
    }

    searchClick(
        selected: string,
        searchText: string     
    ) {
        this.fetchPageset({
            currentPage: 1,
            groupId: this.pageSet.groupId,
            searchField: Number(selected),
            searchText: searchText,
        })       
    }

    pageClickCallback(page: number) {
        this.fetchPageset({
            currentPage: page,
            groupId: this.pageSet.groupId,
            searchField: this.pageSet.searchField,
            searchText: this.pageSet.searchText
        })
    }

    onArticlesChanged(itemsPerPage: number, totalCount: number, page: number, itemCount: number) {
        this.totalCount = totalCount
        this.totalPage = Math.ceil(totalCount / itemsPerPage)

        var startIdx = (page - 1) * itemsPerPage + 1
        this.ofString = `${startIdx} - ${startIdx + itemCount - 1} of ${totalCount}`
    }

    @Watch('$route.query.MENUID')
    onChangedMENUID(val:string){
        var v = menuHelper.findOne(Number(val))
        this.setPage({ title: v?.menuName || '' });
        this.boardGroup = Number(val);
        this.mountAction();
    }
}